import { config } from "lib/constants";

export const toFile = async (path: string): Promise<File> => {
  const response = await fetch(`${config.baseUrl}${path}`);
  const responseBlob = await response.blob();

  return new File([responseBlob], "background.png", { type: "image/png" });
};
